import React from 'react';
import { ReactComponent as PrivateMapSvg } from 'assets/images/contact/private-map.svg';

export const PrivatePlacesMap = () => {
    return <PrivateMapSvg className="w-full h-auto" />;
};
